import type { State } from '../../interfaces/State';
import type { SessionOutput } from '../actions';

export const selectOutput = (state: State): SessionOutput[] =>
  state.get('output').output;

export const selectLastErrorMessage = (state: State): string | null =>
  state.get('output').lastErrorMessage;
